import styles from '../PropertyPanel.module.css';

function ToggleField({ label, value, onChange }) {
  return (
    <label className={styles.toggleField}>
      <span className={styles.fieldLabel}>{label}</span>
      <button
        type="button"
        className={`${styles.toggle} ${value ? styles.toggleOn : ''}`}
        onClick={() => onChange(!value)}
      >
        <span className={styles.toggleThumb} />
      </button>
    </label>
  );
}

export default ToggleField;
